<section *ngIf="loaded===1">
    <div class="cw " fxLayout="column" fxFlex="50%" fxFlex.lt-lg="75%" fxFlex.lt-md="100%"  fxLayoutAlign="center">
        <div fxLayout="column" fxFlex="50%" fxFlex.lt-lg="75%" fxFlex.lt-md="100%" fxLayoutAlign="center">
            <div fxLayout="row" fxLayoutAlign="center">
                <mat-icon class="ftxxxl gray-4 linkIcon"> playlist_add_check</mat-icon>
            </div>
            <div class="mgb10">
                
                <h6 class="h6Title"> Examen de fin de curso </h6>

                <p>El siguiente cuestionario consta de preguntas de selección multiple. Deberas obtener una calificación del
                    igual o superior al 70% para aprobar el examen.
                </p>
                <p class="ft16 gray-6"> ¡Éxito!</p>
            </div>

            <!-- Preguntas -->
            <form>
                <div>
                    <div *ngFor="let pregunta of cuestionario; let pregIndex=index">
                        <div class="mgb20 border pd10 radius3" >
                            <div class="backGray3 mgb10" *ngIf="this.imagenes[pregIndex]">
                                <img src={{this.imagenes[pregIndex]}} alt="" class="fotoPregunta radius3">
                            </div>
                            <div fxLayout="row" fxLayoutGap="1rem" class="mgb10">
                                <span class="ft500 ft15">{{pregIndex + 1}}.</span>
                                <span class="ft500 ft15">{{this.cuestionario[pregIndex].pregunta}}</span>
                            </div>

                            <!-- <input type="text" formControlName="pregunta"> -->
                            <div>
                                <div *ngFor="let opcion of cuestionario[pregIndex].opciones; let optIndex=index">
                                    <div>
                                        <div fxLayout="row" fxLayoutAlign="space-between" class="mgt05">
                                            <div>
                                                <span class="gray-6">
                                                    {{opcion.numero + 1}}.
                                                </span>
                                                <span>
                                                    {{opcion.texto}}
                                                </span>
                                            </div>
                                            <input type="checkbox" value={{optIndex}}
                                                (change)="onCheckChange(pregIndex, $event)">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Enviar -->
                <div fxLayout="row" fxLayoutAlign="end">
                    <div fxLayout="row" fxLayoutAlign=" center" *ngIf="completado===false">
                        <span class="red-3">Debes responder todas las preguntas para continuar a la calificación</span>
                        <button class="mgl10 grayButton gray-5">Evaluar</button>
                    </div>
                    <button (click)="evaluar(); loaded=0" class="darkButton" *ngIf="completado===true">Evaluar</button>
                </div>
            </form>
        </div>
    </div>
</section>

<div *ngIf="loaded===0">
    <div *ssrExclude>
        <spinner></spinner>
    </div>    
</div>